import React from "react";
import {
  MainContext,
  STATUS_ONLINE,
  UIContext,
  UpdateContext,
} from "../main-context";
import { Link } from "react-router-dom";
import common_css from "./offline.module.css";
import no_male from "../assets/images/no_photo_male.jpg";

export default function Common() {
  function createLink(online_status, link, title) {
    if (online_status === STATUS_ONLINE) {
      return (
        <Link
          className={"btn btn-default btn-xs " + common_css["common-min-width"]}
          to={link}
        >
          {title}
        </Link>
      );
    } else {
      return (
        <span
          className={"btn btn-default btn-xs " + common_css["common-min-width"]}
          style={{
            backgroundColor: "#eaeaea",
          }}
        >
          {title}
        </span>
      );
    }
  }

  return (
    <UIContext.Consumer>
      {({ online_status }) => (
        <UpdateContext.Consumer>
          {({ settings }) => (
            <MainContext.Consumer>
              {({ status, constants }) => (
                <div className="row">
                  <div className="col-xs-12 col-sm-6">
                    <div className="row user-profile">
                      <div className="col-xs-12 col-sm-4">
                        {(status.photo && (
                          <div
                            className="img-responsive img-jf-border"
                            style={{
                              background:
                                "url(data:image/gif;base64," +
                                status.photo +
                                ")",
                            }}
                            alt=""
                          ></div>
                        )) || (
                          <img
                            className="img-jf-border img-responsive"
                            src={no_male}
                            alt=""
                          />
                        )}
                      </div>
                      <div className="col-xs-12 col-sm-8">
                        <small>
                          {status.station && (
                            <>
                              <>
                                {"Station: " +
                                  status.station.iata +
                                  " " +
                                  status.station.name}
                              </>
                              <br />
                            </>
                          )}
                          {
                            <>
                              <>
                                {status.vendor &&
                                  "Vendor: " + status.vendor.name}
                              </>
                              <br />
                            </>
                          }
                          {status.station_id && (
                            <>
                              {createLink(
                                online_status,
                                settings.subfolder +
                                  "/online-only/stations/info/" +
                                  status.station_id,
                                "Station Info"
                              )}
                              <br />
                            </>
                          )}
                          {createLink(
                            online_status,
                            settings.subfolder +
                              "/online-only/profile" +
                              status.station_id,
                            "Update Profile"
                          )}
                          <br />
                          {(status.group.name ===
                            constants.AIRPORTAUTHORITY && (
                            <a
                              className={
                                "btn btn-default btn-xs  " +
                                common_css["common-min-width"]
                              }
                              href={settings.url + "/resources"}
                              disabled
                            >
                              Manuals
                            </a>
                          )) ||
                            createLink(
                              online_status,
                              settings.subfolder + "/online-only/resources",
                              "Manuals"
                            )}
                        </small>
                      </div>
                    </div>
                  </div>
                </div>
              )}
            </MainContext.Consumer>
          )}
        </UpdateContext.Consumer>
      )}
    </UIContext.Consumer>
  );
}
